'use client';

import a__default, { forwardRef } from "react";
import b from "../lib/IconBase.js";
import t$1 from "../defs/X.js";
var i = Object.defineProperty, p = Object.defineProperties;
var s = Object.getOwnPropertyDescriptors;
var t = Object.getOwnPropertySymbols;
var c = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
var m = (o, e, r) => e in o ? i(o, e, { enumerable: true, configurable: true, writable: true, value: r }) : o[e] = r, a = (o, e) => {
  for (var r in e || (e = {}))
    c.call(e, r) && m(o, r, e[r]);
  if (t)
    for (var r of t(e))
      n.call(e, r) && m(o, r, e[r]);
  return o;
}, f = (o, e) => p(o, s(e));
const R = forwardRef((o, e) => /* @__PURE__ */ a__default.createElement(b, f(a({ ref: e }, o), { weights: t$1 })));
R.displayName = "X";
export {
  R as X
};
